import React from 'react';
import classnames from 'classnames';
import Element from '../../element';
import MenuList from './list';
import styles from './menu.module.scss';
interface IProps {
    className?: string;
    children: React.ReactNode;
}

function Menu(props: IProps) {
    const { className, children, ...rest } = props;
    return (
        <Element className={classnames(styles.menu, className)} {...rest}>
            {children}
        </Element>
    );
}

Menu.List = MenuList;

export default Menu;
